<div class="keep-shell">

  <!-- HEADER / SEARCH --------------------------------------------------- -->
  <header class="keep-header">
    <div class="brand">
      <!-- <span class="logo-dot"></span> -->
       <i class="fa-solid fa-book"></i>
      <span class="logo-text">Notes</span>
    </div>

    <form [formGroup]="searchForm" class="search">
      <mat-icon class="search-icon">search</mat-icon>
      <input formControlName="query" placeholder="Search notes by text or label…" />
    </form>

    <div class="header-actions">

      <button mat-button (click)="toggleArchivedView()">
        <mat-icon>{{ showArchived ? 'unarchive' : 'archive' }}</mat-icon>
        <span>{{ showArchived ? 'Show active' : 'Show archived' }}</span>
      </button>

      <button mat-button (click)="toggleSelectionMode()">
        <mat-icon>{{ selectionMode ? 'close' : 'checklist' }}</mat-icon>
        <span>{{ selectionMode ? 'Cancel' : 'Select' }}</span>
      </button>

      <button
        mat-raised-button
        color="warn"
        *ngIf="selectionMode && selectedCount > 0"
        (click)="deleteSelected()">

        <mat-icon>delete</mat-icon>
        Delete Selected ({{ selectedCount }})
      </button>

    </div>

  </header>

  <!-- LABEL FILTERS ----------------------------------------------------- -->
  <section class="labels" *ngIf="labels.length">
    <button
      mat-stroked-button
      [color]="!selectedLabel ? 'primary' : ''"
      (click)="selectLabel(null)">
      All
    </button>

    <button
      mat-stroked-button
      *ngFor="let label of labels"
      [class.active]="label === selectedLabel"
      (click)="selectLabel(label)">
      {{ label }}
    </button>
  </section>

  <!-- NEW NOTE INPUT ---------------------------------------------------- -->
  <section class="new-note">
    <form [formGroup]="noteForm" (ngSubmit)="createNote()">
      <div
        class="new-note-card"
        [style.backgroundColor]="noteForm.value.color"
        [style.--note-fg]="getReadableTextColor(noteForm.value.color)">

        <input
          type="text"
          class="title"
          placeholder="Title"
          formControlName="title" />

        <textarea
          class="content"
          placeholder="Take a note…"
          formControlName="content"
          rows="3">
        </textarea>

        <div class="meta-row">
          <div class="labels-input">
            <mat-icon>label</mat-icon>
            <input
              type="text"
              formControlName="labels"
              placeholder="label 1, label 2, etc..." />
          </div>

          <div class="controls">
            <mat-icon
              class="pin-toggle"
              [class.pinned]="noteForm.value.pinned"
              (click)="noteForm.patchValue({ pinned: !noteForm.value.pinned })">
              {{ noteForm.value.pinned ? 'push_pin' : 'push_pin' }}
            </mat-icon>

            <!-- ✅ NEW: Spectrum + Native picker + quick presets -->
            <div class="color-picker" aria-label="Choose note color">

              <!-- Native picker (precise) -->
              <input
                type="color"
                class="native-color"
                [value]="(noteForm.value.color || '').toString().startsWith('#') ? noteForm.value.color : '#0e415d'"
                (input)="onNewNoteHexInput($event)"
                (change)="onNewNoteHexInput($event)"
                aria-label="Pick a custom color" />

              <!-- Hue spectrum -->
              <input
                type="range"
                class="hue-slider"
                min="0"
                max="360"
                [value]="newNoteHsl.h"
                (input)="onNewNoteHueInput($event)"
                aria-label="Hue spectrum" />

              <!-- Lightness / tone -->
              <input
                type="range"
                class="lightness-slider"
                min="20"
                max="95"
                [value]="newNoteHsl.l"
                (input)="onNewNoteLightnessInput($event)"
                aria-label="Lightness" />

              <!-- Quick presets (kept, optional) -->
              <div class="color-dots" aria-label="Quick colors">
                <span
                  *ngFor="let c of colorPalette"
                  class="color-dot"
                  [class.selected]="noteForm.value.color === c"
                  [style.backgroundColor]="c"
                  (click)="setNewNoteColor(c)">
                </span>
              </div>
            </div>

            <button mat-raised-button color="primary" type="submit">
              Add
            </button>
          </div>
        </div>

        <!-- <div class="template-row" *ngIf="noteTemplates.length">
          <span class="template-label">Quick notes:</span>
          <button
            type="button"
            class="template-button"
            *ngFor="let template of noteTemplates"
            (click)="applyNoteTemplate(template)">
            {{ template.title || 'Untitled' }}
          </button>
        </div> -->
      </div>
    </form>
  </section>

  <!-- PINNED NOTES ------------------------------------------------------ -->
  <section class="notes-section" *ngIf="filteredPinned.length">
    <h3 class="section-title pinned-title">Pinned</h3>

    <div
      cdkDropList
      [cdkDropListData]="filteredPinned"
      (cdkDropListDropped)="dropPinned($event)"
      class="notes-grid">

      <article
        class="note-card"
        *ngFor="let n of filteredPinned"
        cdkDrag
        [style.backgroundColor]="n.color"
        [style.--note-fg]="getReadableTextColor(n.color)"
        [class.selected]="isSelected(n)"
        (click)="onNoteClick(n, $event)">

        <div
          class="select-checkbox"
          *ngIf="selectionMode"
          (click)="toggleNoteSelection(n, $event)">
          <mat-icon>
            {{ isSelected(n) ? 'check_circle' : 'radio_button_unchecked' }}
          </mat-icon>
        </div>

        <header class="note-header">
          <h4 class="note-title">{{ n.title || 'Untitled' }}</h4>

          <button
            mat-icon-button
            class="pin-btn pinned"
            (click)="togglePinned(n, false); $event.stopPropagation()">
            <mat-icon>push_pin</mat-icon>
          </button>
        </header>

        <div class="note-content" [class.truncated]="isLong(n)">
          {{ n.content }}
        </div>

        <footer class="note-footer">
          <div class="labels-chips">
            <span class="chip" *ngFor="let label of n.labels">{{ label }}</span>
          </div>

          <div class="note-actions">
            <button
              mat-icon-button
              [matMenuTriggerFor]="noteMenuPinned"
              matTooltip="More"
              (click)="$event.stopPropagation()">
              <mat-icon>more_horiz</mat-icon>
            </button>

            <button mat-icon-button (click)="useInChat(n)" matTooltip="Insert into ClariChat">
              <mat-icon>send</mat-icon>
            </button>

            <button mat-icon-button [matMenuTriggerFor]="colorMenu" matTooltip="Color">
              <mat-icon>palette</mat-icon>
            </button>

            <button
              mat-icon-button
              (click)="delete(n); $event.stopPropagation()"
              matTooltip="Delete">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </footer>

        <mat-menu #noteMenuPinned="matMenu">
          <button mat-menu-item (click)="archive(n); $event.stopPropagation()">
            <mat-icon>{{ n.archived ? 'unarchive' : 'archive' }}</mat-icon>
            <span>{{ n.archived ? 'Unarchive' : 'Archive' }}</span>
          </button>
          <button mat-menu-item (click)="shareNote(n, $event)">
            <mat-icon>person_add</mat-icon>
            <span>Share with user</span>
          </button>
        </mat-menu>

        <!-- ✅ NEW: menu with spectrum sliders + native picker -->
        <mat-menu #colorMenu="matMenu" class="note-color-menu">
          <div class="note-color-panel" (click)="$event.stopPropagation()">
            <div class="row">
              <input
                type="color"
                class="native-color"
                [value]="(n.color || '').toString().startsWith('#') ? n.color : '#0e415d'"
                (input)="onExistingHexInput(n, $event)"
                (change)="onExistingHexInput(n, $event)"
                aria-label="Pick a custom color" />
              <span class="hex">{{ n.color }}</span>
            </div>

            <div class="row sliders">
              <label class="lbl">Hue</label>
              <input
                type="range"
                class="hue-slider"
                min="0"
                max="360"
                [value]="getExistingHue(n)"
                (input)="onExistingHueInput(n, $event)"
                aria-label="Hue spectrum" />
            </div>

            <div class="row sliders">
              <label class="lbl">Tone</label>
              <input
                type="range"
                class="lightness-slider"
                min="20"
                max="95"
                [value]="getExistingLightness(n)"
                (input)="onExistingLightnessInput(n, $event)"
                aria-label="Lightness" />
            </div>

            <div class="menu-presets" aria-label="Quick colors">
              <button
                type="button"
                class="preset-dot"
                *ngFor="let c of colorPalette"
                [style.backgroundColor]="c"
                (click)="setExistingNoteColor(n, c, $event)">
              </button>
            </div>
          </div>
        </mat-menu>
      </article>
    </div>
  </section>

  <!-- NOTES ------------------------------------------------------- -->
  <section class="notes-section" *ngIf="filteredOthers.length">
    <h3 class="section-title notes-title">Notes</h3>

    <div
      cdkDropList
      [cdkDropListData]="filteredOthers"
      (cdkDropListDropped)="dropOthers($event)"
      class="notes-grid">

      <article
        class="note-card"
        *ngFor="let n of filteredOthers"
        cdkDrag
        [style.backgroundColor]="n.color"
        [style.--note-fg]="getReadableTextColor(n.color)"
        [class.selected]="isSelected(n)"
        (click)="onNoteClick(n, $event)">

        <div
          class="select-checkbox"
          *ngIf="selectionMode"
          (click)="toggleNoteSelection(n, $event)">

          <mat-icon>
            {{ isSelected(n) ? 'check_circle' : 'radio_button_unchecked' }}
          </mat-icon>
        </div>

        <header class="note-header">
          <h4 class="note-title">{{ n.title || 'Untitled' }}</h4>
          <div class="note-header-actions">
            <button
              mat-icon-button
              class="pin-btn"
              [class.pinned]="n.pinned"
              (click)="togglePinned(n, true); $event.stopPropagation()">
              <mat-icon>push_pin</mat-icon>
            </button>
          </div>
        </header>

        <div class="note-content" [class.truncated]="isLong(n)">
          {{ n.content }}
        </div>

        <footer class="note-footer">
          <div class="labels-chips">
            <span class="chip" *ngFor="let label of n.labels">{{ label }}</span>
          </div>

          <div class="note-actions">
            <button
              mat-icon-button
              [matMenuTriggerFor]="noteMenuOther"
              matTooltip="More"
              (click)="$event.stopPropagation()">
              <mat-icon>more_horiz</mat-icon>
            </button>

            <button mat-icon-button (click)="useInChat(n)" matTooltip="Insert into ClariChat">
              <mat-icon>send</mat-icon>
            </button>

            <button mat-icon-button [matMenuTriggerFor]="colorMenu2" matTooltip="Color">
              <mat-icon>palette</mat-icon>
            </button>

            <button
              mat-icon-button
              (click)="delete(n); $event.stopPropagation()"
              matTooltip="Delete">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </footer>

        <mat-menu #noteMenuOther="matMenu">
          <button mat-menu-item (click)="archive(n); $event.stopPropagation()">
            <mat-icon>{{ n.archived ? 'unarchive' : 'archive' }}</mat-icon>
            <span>{{ n.archived ? 'Unarchive' : 'Archive' }}</span>
          </button>
          <button mat-menu-item (click)="shareNote(n, $event)">
            <mat-icon>person_add</mat-icon>
            <span>Share with user</span>
          </button>
        </mat-menu>

        <!-- ✅ NEW: menu with spectrum sliders + native picker -->
        <mat-menu #colorMenu2="matMenu" class="note-color-menu">
          <div class="note-color-panel" (click)="$event.stopPropagation()">
            <div class="row">
              <input
                type="color"
                class="native-color"
                [value]="(n.color || '').toString().startsWith('#') ? n.color : '#0e415d'"
                (input)="onExistingHexInput(n, $event)"
                (change)="onExistingHexInput(n, $event)"
                aria-label="Pick a custom color" />
              <span class="hex">{{ n.color }}</span>
            </div>

            <div class="row sliders">
              <label class="lbl">Hue</label>
              <input
                type="range"
                class="hue-slider"
                min="0"
                max="360"
                [value]="getExistingHue(n)"
                (input)="onExistingHueInput(n, $event)"
                aria-label="Hue spectrum" />
            </div>

            <div class="row sliders">
              <label class="lbl">Tone</label>
              <input
                type="range"
                class="lightness-slider"
                min="20"
                max="95"
                [value]="getExistingLightness(n)"
                (input)="onExistingLightnessInput(n, $event)"
                aria-label="Lightness" />
            </div>

            <div class="menu-presets" aria-label="Quick colors">
              <button
                type="button"
                class="preset-dot"
                *ngFor="let c of colorPalette"
                [style.backgroundColor]="c"
                (click)="setExistingNoteColor(n, c, $event)">
              </button>
            </div>
          </div>
        </mat-menu>
      </article>
    </div>
  </section>

  <!-- EMPTY STATE ------------------------------------------------------- -->
  <section class="empty-state" *ngIf="!filteredPinned.length && !filteredOthers.length">
    <mat-icon>lightbulb</mat-icon>
    <p>Notes you add appear here. Pin your most important prompts and send them straight into ClariChat.</p>
  </section>

</div>
